import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const QrCodeIcon: FC<SvgIconProps> = (props) => (
	<SvgIcon {...props}>
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3 3H7.5V7.5H3V3ZM15 3V7.5H10.5V3H15ZM10.5 11.25H12V9.75H10.5V8.25H12V9.75H13.5V8.25H15V9.75H13.5V11.25H15V13.5H13.5V15H12V13.5H9.75V15H8.25V12H10.5V11.25ZM12 11.25V13.5H13.5V11.25H12ZM3 15V10.5H7.5V15H3ZM4.5 4.5V6H6V4.5H4.5ZM12 4.5V6H13.5V4.5H12ZM4.5 12V13.5H6V12H4.5ZM3 8.25H4.5V9.75H3V8.25ZM6.75 8.25H9.75V11.25H8.25V9.75H6.75V8.25ZM8.25 4.5H9.75V7.5H8.25V4.5ZM1.5 1.5V4.5H0V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0L4.5 0V1.5H1.5ZM16.5 0C16.8978 0 17.2794 0.158035 17.5607 0.43934C17.842 0.720644 18 1.10218 18 1.5V4.5H16.5V1.5H13.5V0H16.5ZM1.5 13.5V16.5H4.5V18H1.5C1.10218 18 0.720644 17.842 0.43934 17.5607C0.158035 17.2794 0 16.8978 0 16.5V13.5H1.5ZM16.5 16.5V13.5H18V16.5C18 16.8978 17.842 17.2794 17.5607 17.5607C17.2794 17.842 16.8978 18 16.5 18H13.5V16.5H16.5Z"
				fill="currentColor"
			/>
		</svg>
	</SvgIcon>
);
